function initGoogleMaps() {

  var MY_MAPTYPE_ID = 'custom_style';

  var featureOpts = [
      {
      "featureType": "administrative.locality",
      "elementType": "labels",
      "stylers": [
        { "color": "#4a4742" },
        { "weight": 0.2 }
      ]
      },{
      "elementType": "geometry",
      "stylers": [
        { "saturation": -88 },
        { "lightness": 23 }
      ]
      },{
      "featureType": "road.highway.controlled_access",
      "elementType": "labels",
      "stylers": [
        { "visibility": "on" },
        { "saturation": -95 }
      ]
      },{
      "featureType": "road.highway",
      "elementType": "labels.icon",
      "stylers": [
        { "visibility": "on" },
        { "saturation": -100 },
        { "lightness": 33 }
      ]
      },{
      "featureType": "poi",
      "stylers": [
        { "visibility": "on" },
        { "saturation": -100 }
      ]
      },{
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        { "visibility": "on" },
        { "saturation": -100 },
        { "lightness": 34 }
      ]
      },{
      "featureType": "water",
      "stylers": [
        { "color": "#FFF" }
      ]
      },{
      "featureType": "transit",
      "elementType": "labels",
      "stylers": [
        { "weight": 0.3 },
        { "saturation": -100 }
      ]
      },{
      "featureType": "road",
      "elementType": "labels.text",
      "stylers": [
        { "saturation": -100 }
      ]
      },
      // {
      //   "featureType": "poi.park",
      //   "elementType": "geometry",
      //   "stylers": [
      //     { "lightness": 23 },
      //     { "color": "#a0e6af" }
      //   ]
      // }
  ]

  var map = new google.maps.Map(document.getElementById('map-canvas'), {
      zoom: 9,
      center: new google.maps.LatLng(49.921042, 9.148527),
      streetViewControl: false,
      mapTypeId: MY_MAPTYPE_ID,
      scrollwheel: false,
      mapTypeControl: false,
      // panControl:true,
      draggable: $("html").hasClass("no-touch")
  });

  // limit the zoom level
  var maxZoomLevel = 6;
  google.maps.event.addListener(map, 'zoom_changed', function() {
    if (map.getZoom() < maxZoomLevel) map.setZoom(maxZoomLevel);
  });

  var styledMapOptions = {
      name: 'Custom Style'
  };

  var locations = [
      ['', 49.979037, 9.143243, 4],
      ['<a href="https://goo.gl/maps/4npV8xFQPGLxFMpB6" target="blank"> ' + lang_routenplanung + '</a>', 49.978551739810094, 9.14412666717541, 3],
      ['<a href="https://goo.gl/maps/hnD3ZMFXsLcS28aD6" target="blank"> ' + lang_routenplanung + '</a>', 49.96481390921216, 9.173478269638954, 3],
  ];

  // Setup the different icons and shadows
  var iconURLPrefix = IMG_PATH + 'marker_';

  var icons = [
    iconURLPrefix + 'ab.png',
    iconURLPrefix + 'ab_weissenburger_str.png',
    iconURLPrefix + 'ab_bamberger_str.png',
  ]
  var icons_length = icons.length;

  var marker;
  var markers = new Array();

  var iconCounter = 0;
  var bounds = new google.maps.LatLngBounds();
  var infowindow = new google.maps.InfoWindow();

  // Add the markers and infowindows to the map
  for (var i = 0; i < locations.length; i++) {

      marker = new google.maps.Marker({
          position: new google.maps.LatLng(locations[i][1], locations[i][2]),
          map: map,
          icon : icons[iconCounter],
      });

      markers.push(marker);
      bounds.extend(marker.position);

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
          return function() {
              map.setZoom(16);
              map.setCenter(marker.getPosition());

              if (i != 0) {
                  infowindow.setContent(locations[i][0]);
                  infowindow.open(map, marker);
              }

          }
      })(marker, i));

      iconCounter++;
      // We only have a limited number of possible icon colors, so we may have to restart the counter
      if(iconCounter >= icons_length){
          iconCounter = 0;
      }
  }

  /* trigger from outside */
  $('.google-map__trigger-item').each(function(i){
      $(this).on('click', function(){
          google.maps.event.trigger(markers[(i+1)], 'click');
      });
  });


  var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);

  map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

}
